<template>
  <div class="container activation-options welcome-back">
    <h1 class="section-title">Rica Details</h1>

    <div>
      <div class="subscriber-details">
        <!-- <span class="details">Your Details</span> -->
        <div style="position:relative">
          <span class="details">ENTER CUSTOMER RICA DETAILS</span>
          <a class="clear-input" @click="clearForm">
            Clear
            <i class="fa fa-times"></i>
          </a>
        </div>

        <!-- <vue-port-details :details.sync="subscriber.port_details" /> -->

        <div class="Document-upload">
          <label class="section-label">Documents</label>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Proof of Address</label>
                <upload-btn
                  class="btn btn-dark btn-block"
                  :ripple="false"
                  title="Upload"
                  @file-update="address_file"
                ></upload-btn>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>Copy of {{subscriber.id_type}}</label>
                <upload-btn
                  class="btn btn-dark btn-block"
                  :ripple="false"
                  title="Upload"
                  @file-update="id_file"
                ></upload-btn>
              </div>
            </div>
          </div>
          <div class="error-message" v-if="uploads_error != ''">{{ uploads_error }}</div>
        </div>

        <vue-address-details
          :details.sync="address_details"
          @updated:address="updateAddress"
          type="Residential"
          errorMessage="Street Address is required. Please type your residential street address for RICA."
        ></vue-address-details>
        <div class="error-message" v-if="address_error != ''">{{ address_error }}</div>

        <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
        <div class="page-controls mt-3">
          <div class="row no-gutters">
            <button type="button" class="col btn btn-primary next" v-on:click="validate">
              Submit
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/components/shared/event-bus';
import SubscriberService from "@/services/subscriber.service.js";

import VueAddressDetails from "@/components/elements/vue-address-details";
import UploadButton from "vuetify-upload-button";

import AddressModel from "@/models/address.model";

export default {
  name: "rica-details",
  components: {
    "upload-btn": UploadButton,
    "vue-address-details": VueAddressDetails
  },
  props: ["subscriber"],
  data: function() {
    return {
      is_loading: false,
      error_message: "",
      address_error: "",
      uploads_error: "",
      address_details: new AddressModel(),
      files: []
    };
  },
  methods: {
    updateAddress(address) {
      var self = this;
      self.address_details = address;
    },
    address_file(file) {
      var self = this;
      self.$log.debug("address file : " + file);
      self.files.push({ file: file, type: "address" });
    },
    id_file(file) {
      var self = this;
      self.$log.debug("id file : " + file);
      self.files.push({ file: file, type: "id" });
    },
    validate() {
      var self = this;
      self.error_message = "";
      self.uploads_error = "";
      self.address_error = "";
      self.$log.debug("validate");
      var has_errors = false;
      if (!self.address_details.is_valid) {
        self.address_error = "Invalid address. Please correct to Activate.";
        has_errors = true;
      }
      if (self.files.length < 2) {
        self.uploads_error =
          "Invalid uploads. Please upload all required documents.";
        has_errors = true;
      }
      if (!has_errors) {
        self.submit();
      } else {
        self.error_message = "Invalid inputs.";
      }
    },
    submit() {
      var self = this;
      EventBus.$emit("global_loading", { is_loading: true });
      self.is_loading = true;
      SubscriberService.ricaSubscriber(       
        self.subscriber,
        self.address_details,
        self.files
      )
        .then(response => {
          EventBus.$emit("global_loading", { is_loading: false });
          self.is_loading = false;
          self.$log.debug(response);
          if (response.data.success) {       
            self.$emit('updated', response.data.success);
          } else {
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          } 
        })
        .catch(() => {
          self.is_loading = false;
          self.error_message =
            "Unfortunately we cannot complete this request. Please contact support.";
        });
    },
    clearForm() {
      var self = this;
      self.address_details = new AddressModel();
      self.files = [];
      self.promo_code = "";
    }
  }
};
</script>